module.exports = __webpack_public_path__ + "images/emoji/lemon.6e32ab9e3bb4a05471b3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lemon.png
// module id = HuBZ
// module chunks = 1